export default "__VITE_ASSET__Bhgi8ZeV__"